import React from 'react';
import { Typography } from '@mui/material';
import moment from 'moment-timezone';
import { DATE_TIME_FORMATS } from '../enums/AppConsts';

export const displayText = (text: string | null, type?: string | undefined) => {
  if (type && type === 'money') {
    return (
      <Typography
        sx={{
          fontWeight: 500,
          fontSize: '14px'
        }}
      >
        {Number(text).toFixed(2)}
      </Typography>
    );
  }
  return (
    <Typography
      sx={{
        fontWeight: 500,
        fontSize: '14px'
      }}
    >
      {text}
    </Typography>
  );
};

export const formatDate = (
  value: string | number | undefined | null,
  format: string = DATE_TIME_FORMATS.DATE
) => {
  if (value) {
    return !isNaN(value) && !isNaN(parseFloat(value))
      ? moment(parseInt(value.toString() as string)).format(format)
      : moment(value).format(format);
  }
  return '';
};

export const validEmailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const validWebsiteRegex =
  /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gim;

// const formatDate = (rowData: IMembership, name: string, nestedName?: string) => {
//     if (name && nestedName) {
//       // eslint-disable-next-line @typescript-eslint/ban-ts-comment
//       // @ts-ignore
//       return rowData[name] && rowData[name][nestedName]
//         ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
//           // @ts-ignore
//           moment(parseInt(rowData[name][nestedName] as string)).format(DATE_TIME_FORMATS.DATE)
//         : '';
//     } else {
//       // eslint-disable-next-line @typescript-eslint/ban-ts-comment
//       // @ts-ignore
//       return rowData[name]
//         ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
//           // @ts-ignore
//           moment(parseInt(rowData[name] as string)).format(DATE_TIME_FORMATS.DATE)
//         : '';
//     }
//   };
